import { CustomerDocument } from "@/core/customers/entities/CustomerDocuments";
import GetCustomerDocumentsUseCase from "@/core/customers/useCases/GetCustomerDocumentsUseCase/GetCustomerDocumentsUseCase";
import type { FicheClient360State, FicheClient360StoreDeps } from "../types";
import { createFetchAction } from "../helpers";

export function createDocumentsSlice(
  deps: FicheClient360StoreDeps,
  set: (partial: Partial<FicheClient360State>) => void,
): Partial<FicheClient360State> {
  const getCustomerDocumentsUseCase = new GetCustomerDocumentsUseCase(
    deps.customerDocumentsRepository,
  );

  return {
    fetchDocuments: createFetchAction<CustomerDocument[]>(
      set,
      "documentsLoading",
      "documentsError",
      "documents",
      (businessKey) => getCustomerDocumentsUseCase.execute(businessKey),
      "Erreur lors du chargement des documents :",
      () => [],
    ),
  };
}
